export default class Expandable {
    constructor(_root, _triggerClassName, _onStateChange, initialState) {
        this.root = _root;
        this.trigger = Array.from(this.root.querySelectorAll(_triggerClassName));
        this.onStateChange = _onStateChange;
        this.setupEventListeners();
        this.initialize(initialState);
    }
    setupEventListeners() {
        this.trigger.forEach((_toggleButton) => {
            _toggleButton.addEventListener("click", this.toggle.bind(this));
        });
    }
    initialize(initialState) {
        const header = this.root.querySelector("[aria-expanded]");
        header.setAttribute("aria-expanded", String(initialState));
        if (initialState) {
            // default is closed
            this.root.classList.add("neos-open");
            this.changeToogleIcon();
        }
    }
    toggle() {
        this.changeToogleIcon();
        this.root.classList.toggle("neos-open");
        this.toogleAriaExpandable();
    }
    toogleAriaExpandable() {
        const header = this.root.querySelector("[aria-expanded]");
        const expanded = this.root.classList.contains("neos-open");
        header.setAttribute("aria-expanded", String(expanded));
        if (typeof this.onStateChange === "function") {
            const sectionName = this.root.getAttribute("data-key");
            this.onStateChange(sectionName, expanded);
        }
    }
    changeToogleIcon() {
        const openIcon = this.root.querySelector(".fa-chevron-circle-down");
        const closeIcon = this.root.querySelector(".fa-chevron-circle-up");
        if (openIcon) {
            openIcon.classList.replace("fa-chevron-circle-down", "fa-chevron-circle-up");
        }
        if (closeIcon) {
            closeIcon.classList.replace("fa-chevron-circle-up", "fa-chevron-circle-down");
        }
    }
}
